import { useNode } from "@craftjs/core";
import {
  FormControl,
  FormLabel,
  TextField,
  Box,
  Stack,
} from "@mui/material";
import { ImageUploader } from "./ImageUploader";

interface CImageProps {
  width?: any;
  height?: any;
  src?: any;
  [key: string]: any;
}

export const CImage = ({ width, height, src, ...props }: CImageProps) => {
  const {
    connectors: { connect, drag },
    selected
  } = useNode((node) => ({
    selected: node.events.selected,
  }));

  return (
    <img
      {...props}
      ref={(ref: any) => connect(drag(ref))}
      className="craft-image"
      width={width}
      height={height}
      src={src}
      style={{
        borderColor: selected ? '#008522' : '#F0F0F0'
      }}
    />
  );
};

export const CImageSettings = () => {
  const {
    actions: { setProp },
    props,
    selected,
  } = useNode((node) => ({
    props: node.data.props,
    selected: node.events.selected,
  }));

  return (
    <Stack spacing={2} paddingBottom={4}>
      <FormControl size="small" component="fieldset">
        <FormLabel component="legend">Source</FormLabel>
        <ImageUploader onImageChange={(url: string) => setProp((props: any) => (props.src = url), 500)} />
      </FormControl>
      <Stack direction='row' spacing={4}>
        <FormControl size="small" component="fieldset">
          <FormLabel component="legend">Width</FormLabel>
          <TextField
            value={props.width || ''}
            onChange={(e) =>
              setProp((props: CImageProps) => (props.width = e.target.value))
            }
            variant="outlined"
            size="small"
          />
        </FormControl>
        <FormControl size="small" component="fieldset">
          <FormLabel component="legend">Height</FormLabel>
          <TextField
            value={props.height || ''}
            onChange={(e) =>
              setProp((props: CImageProps) => (props.height = e.target.value))
            }
            variant="outlined"
            size="small"
          />
        </FormControl>
      </Stack>
    </Stack>
  );
};

export const CImageDefaultProps: CImageProps = {
  width: '100px',
  height: '100px',
  src: "",
};

CImage.craft = {
  displayName: "Image",
  props: CImageDefaultProps,
  related: {
    settings: CImageSettings,
  },
};
